import { Component, OnInit } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ToastrService } from 'ngx-toastr';
import { ObjectSelect } from 'src/app/shared/model/models';
import { Router } from '@angular/router';

@Component({
  selector: 'app-object-add',
  templateUrl: './object-add.component.html',
  styleUrls: ['./object-add.component.less']
})
export class ObjectAddComponent implements OnInit {

  relatieid: number;
  cpid: number;
  faseid: number;
  objectNR: number;
  objectSerieNR: number;
  accountmanager: number;
  object: string;
  medewerkers: any = null;


  relaties = [];
  contactpersonen = [];
  fasen = [];

  constructor(private relatiesService: RelatiesService,
              private objectenService: ObjectenService,
              private router: Router,
              private toastr: ToastrService) {
                console.log("TEST")
               }

  ngOnInit() {
    console.log("inint");
    this.relatiesService.getActiveRelatieList().subscribe(data => {
      this.relaties = data;
    })
    this.objectenService.getFasen().subscribe(data=> this.fasen = data)
    this.objectenService.getMedewerkers().subscribe(data => {
      this.medewerkers = data;
    })
    const data = localStorage.getItem("objectfilter");
    if (data) {
      const os = JSON.parse(data) as ObjectSelect;
      this.relatieChange(os.relatieid);
      this.cpChange(os.cpid);
      this.faseChange(os.faseid);


    }
  }

  relatieChange(data: any) {
    this.relatieid = data;
    this.relatiesService.getContactpersonen(this.relatieid).subscribe(data => {
      this.contactpersonen = data;
    })
  }

  cpChange(data:any) {
    this.cpid = data;
  }

  faseChange(data:any) {
    this.faseid = data;
  }

  objNrChange(target:any) {
    const element = target as HTMLInputElement
    this.objectNR = Number(element.value) ;
  }

  objNrSerieChange(target:any) {
    const element = target as HTMLInputElement
    this.objectSerieNR = Number(element.value) ;
  }

  doFilter() {
    let oselect = new ObjectSelect();
    oselect.cpid = this.cpid;
    oselect.faseid = this.faseid;
    oselect.relatieid = this.relatieid;
    oselect.objectNr = this.objectNR;
    oselect.objectSerieNr = this.objectSerieNR;
    oselect.AccountManager = this.accountmanager;
    oselect.object = this.object;
    localStorage.setItem("objectfilter",JSON.stringify(oselect));
    this.objectenService.postObject(oselect).subscribe(data => {
      this.router.navigateByUrl('/objecten');
    })

    //this.selectionChanged.emit(oselect)
  }



}
